import { render, staticRenderFns } from "./OfferInsights.vue?vue&type=template&id=4c6e3a0c&scoped=true&lang=pug&"
import script from "./OfferInsights.vue?vue&type=script&lang=js&"
export * from "./OfferInsights.vue?vue&type=script&lang=js&"
import style0 from "./OfferInsights.vue?vue&type=style&index=0&id=4c6e3a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e3a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VProgressCircular,VRow,VSkeletonLoader,VSpacer})
